import { render, staticRenderFns } from "./JobAssign.vue?vue&type=template&id=3124eee6&scoped=true&"
import script from "./JobAssign.vue?vue&type=script&lang=js&"
export * from "./JobAssign.vue?vue&type=script&lang=js&"
import style0 from "./JobAssign.vue?vue&type=style&index=0&id=3124eee6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124eee6",
  null
  
)

export default component.exports